import { ThemeParameter, ThemeVariable } from './theme.contracts';

export const defaultTheme: Record<ThemeVariable, string> = {
	'active-color': '#2364e4',
	'action-btn-color': '#2364e4',
	'btn-color': '#1492d9',

	'header-icon-color': '#94a1b7',
	'header-bg-color': '#ffffff',
	'header-text-color': '#003c71',

	'body-icon-color': '#4D596B',
	'body-text-color': '#4D596B',
	'body-bg-color': '#ffffff',

	'content-icon-color': '#4D596B',
	'content-text-color': '#383d51',
	'content-bg-color': '#ffffff',
	'default-font-color': '#383d51',

	'base-layout-color': '#2364e4',

	'unified-search-bg-color': '#3187b8',

	applicationLogoUrl:
		'"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG0AAAAPCAIAAABhptZQAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAOqSURBVFhHrZcxaxRBFMeTb6DfwDadVSoDBlJoZ8Be7TWondcoSLAxCHJ2ISIIIkIUgiAoKOmuicRCiRYGPCSNGhJImtzqb/ftzb39z+yaO+7xL27fe7Mz85s3s3MTswuPzl6r6M7Km7/O/uwfSAJ6/LpThp1duLUiae83vlmIfAkldf3hq49fu+L0oosHzz8wJHstRhOfgCfuy+e/XP8k0e8/f2U7X3pPL4myt/fKNoX1Nld7L64eLU0fLU6h3vI8Cdlu16ITkzM3J87cEPmOGbdE0e0qa4zxSQ5i2hZlbSSUFLMCvThjnTjXAre9mSY+hIfBn7p41zthbcl1IaAYHS9QWisoH7XnJBoEX3LSHGFnr8CkY1PM8fLiM8kxsdpEx8sRgdLeHHPEoOydyLjLMJgaZLP1tqAxBY4NEE3ZdifN8fSV+/aKeEAm4choJCHIlmTsHJGVUpIjJj2SBvfJmYEH0VdeaxEX06AetzsDf3sOv5Blv6c5IlvAuioTjrL3KZbwmzUvk/ompJhwGShMoqEjlkp6AQ3+Oo4Y1eBDsrGs38qOXprurbXCY+CIsXmJArR8xgPNkLk8X8sRgr/3DzwRL+Hoh0gTqQXQlHmFjcYRk6r/L8e6zYRsw8mO7nWeeI/nGFv+zQmZwlFw+PUXoH56MnMWQCaAp0wtbCiOYCLBJAVlH7EGjhitfDSIEVZ2a5/aMTnm5enbrrUqHBkTgwuPXhxG/tFzlL3PhxunzJlSsmRsKI4NsrtXM8fkwU0TQr6g8j27+wPncTgKxKJtVzkmry9Aken5Y8uXKr/NL9z9BWAsHEONN3OUYQQxTSY/uAyutShPVDkfuSHi7N8QzbgzhgSTHZrKEZeUEmI0dRwpCu+HIy9BcsbzmGXWYgwcfZMGjsmaMDFOKoADUaDEokLL1x3u+W9LLipx650FExzjNeTGUMdReDVoY6tc2KE4Und45LTx1V3HUTYKkqHa8VrZ3SkZx/ww7RdvqfZctvO56Cq3BEeoBU9wJjk2fBBjhZ04FEfrSIZk1WT5dRwFPY80OXm+QjZfj8M9BVQVHJNly66nPIMSHDE/ODvOk9OrO32SCpMfgSMmXEKrJMf4tLE/P0k/ezPgqFywuU7i3FzN/cFZozTH0B89mSc5PaLeyfKS5iVHbXJJjslR/AFNzBF/PLDiHblJfpiyWfJ7PTpHzIZCxdljPL14bS3TmxSs3X5H44gJAjsoYo6zCxWPdRqsmfKIHBen/gEBLf9ZGek14gAAAABJRU5ErkJggg=="',
	'icons-font-path': 'assets/fonts/MaterialIcons-Regular',

	'success-color': '#bef8e8',
	'warning-color': '#ffefb5',
	'info-color': '#c0edff',
	'error-color': '#ffcbd5',

	'palette-color1': '#1492D9',
	'palette-color2': '#FBD77B',
	'palette-color3': '#FF6666',
	'palette-color4': '#8380FF',
	'palette-color5': '#FFB4A9',
	'palette-color6': '#A4DAF9',
	'palette-color7': '#A2D1DF',
	'palette-color8': '#485D70',
	'palette-color9': '#89B6A6',
	'palette-color10': '#42AC86',
	'palette-color11': '#6FE8BC',
	'palette-color12': '#cf447b',
} as const;

export const defaultThemeParams = Object.entries(defaultTheme).map(([Key, Value]) => ({ Key, Value })) as ThemeParameter[];
